import { SectionHeader } from '../SectionHeader';
import { Reveal } from '../Reveal';

// Section 15 — implementation and expert support. The partner note only
// renders when an approved partner line is configured in the CMS.
export const ForeseeImplementation = ({ sp }) => (
  <section aria-labelledby="foresee-implementation-heading" data-testid="foresee-implementation" className="bg-mist py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        index="15"
        eyebrow="Implementation & Support"
        title="Technology supported by practical EHSQ expertise"
        description={sp.implementationCopy}
        testid="foresee-implementation-header"
      />
      <ol className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {(sp.stages || []).map((stage, i) => (
          <Reveal key={stage.title} delay={i * 0.08} className="h-full">
            <li className="flex h-full flex-col rounded-xl border border-slate-200 bg-white p-6" data-testid={`foresee-stage-${i + 1}`}>
              <span className="font-mono text-sm font-bold tracking-widest text-indigo-600">{String(i + 1).padStart(2, '0')}</span>
              <h3 className="mt-3 text-lg font-extrabold tracking-tight text-navy-900">{stage.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{stage.text}</p>
            </li>
          </Reveal>
        ))}
      </ol>
      {sp.partnerNote && (
        <p className="mx-auto mt-10 max-w-2xl rounded-xl border border-slate-200 bg-white p-5 text-center text-sm font-semibold text-navy-900" data-testid="foresee-partner-note">
          {sp.partnerNote}
        </p>
      )}
    </div>
  </section>
);
